export const cateringData = [
    {
        src: 'assets/images/1a.jpg',
        altText: 'Slide 1'
    },
    {
        src: 'assets/images/2a.jpg',
        altText: 'Slide 2'
    },
    {
        src: 'assets/images/3a.jpg',
        altText: 'Slide 3'
    },
    {
        src: 'assets/images/4a.jpg',
        altText: 'Slide 4'
    },
    {
        src: 'assets/images/5a.jpg',
        altText: 'Slide 5'
    },
    {
        src: 'assets/images/6a.jpg',
        altText: 'Slide 6'
    },
    {
        src: 'assets/images/7a.jpg',
        altText: 'Slide 7'
    },
    {
        src: 'assets/images/8a.jpg',
        altText: 'Slide 8'
    },
    {
        src: 'assets/images/9a.jpg',
        altText: 'Slide 9'
    },
    {
        src: 'assets/images/10a.jpg',
        altText: 'Slide 10'
    },
];